import { store } from './store';
export function createGetReState(key) {
  return function () {
    return store.get(key);
  };
}